import React, { FC } from 'react';
import { Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Form } from '~/components';
import { usePath } from '~/hooks';
import { inputWidth } from '~/utils/filters';

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation('locations');
  const { changePath, params } = usePath();

  const handleChange = (changed: any, values: Record<string, any>) => {
    changePath({ filter: values });
  };

  return (
    <Form form={form} layout="inline" onValuesChange={handleChange} initialValues={params.filter}>
      <Form.Item name="status">
        <Select
          allowClear
          placeholder={t('status:status')}
          options={[
            { value: 'ACTIVE', label: t('status:ACTIVE') },
            { value: 'BLOCKED', label: t('status:BLOCKED') },
            { value: 'CLOSED', label: t('status:CLOSED') },
          ]}
          style={inputWidth}
        />
      </Form.Item>
      <Form.Item name="city">
        <Input placeholder={t('city')} allowClear style={inputWidth} />
      </Form.Item>
      <Form.Item name="region">
        <Input placeholder={t('region')} allowClear style={inputWidth} />
      </Form.Item>
    </Form>
  );
};

export default Filters;
